import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import useDefaultFeeStateHook from "../../hooks/useDefaultFeeStateHook";

export const DefaultSettingTax = ({ fee, isLoading }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [feeState, setFeeStateWithUpdate] = useDefaultFeeStateHook(fee)

    if (!feeState) return null;

    return (
        <TableRow
            key={fee.id}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={isTabletOrMobile ? '60%' : '40%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {feeState.name}
                </div>
            </TableCell>
            {/* Empty spacer so Capped lands in the same column as the Fees Capped */}
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
            <TableCell
                className={'DealPageFee'}
                align="center"
                size={'small'}
                width={'20%'}
            >
                <Tooltip title={feeState.is_tax_capped ? 'Upfront' : 'Cap'} arrow placement={'top'}>
                    <Switch
                        disabled={isLoading}
                        checked={feeState.is_tax_capped}
                        onChange={() => {
                            setFeeStateWithUpdate({is_tax_capped: !feeState.is_tax_capped}, true, true)
                        }}
                    />
                </Tooltip>

            </TableCell>
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
        </TableRow>
    )
}